const ELEARNING_ROLES = {
    admin: 'Quản trị viên',
    manager: 'Quản lý lớp học',
    student: 'Học viên',
    editingteacher: 'Giáo viên',
}

const QUIZ_ATTEMPT_STATUS = {
    inprogress: 'Đang làm bài',
    finished: 'Đã thực hiện',
    overdue: 'Quá hạn',
    suspended: 'Tạm dừng',
    notattempted: 'Chưa làm bài',
    abandoned: 'Đã bị huỷ',
}

const QUIZ_GRADE_STATUS = {
    gradedwrong: 'Trả lời sai',
    gradedright: 'Trả lời đúng',
    gradedpartial: 'Đúng một phần',
    gaveup: 'Không trả lời',
}

const COURSE_MODULES = {
    quiz: 'Bài kiểm tra',
    supervideo: 'Video',
    url: 'Liên kết',
    resource: 'Tài liệu',
    page: 'Trang',
    forum: 'Diễn đàn',
    book: 'Giáo trình',
}

// Layout poll today-time interval. Bump 5 → 10 phút giảm 50% Moodle WS
// load (mỗi call fan out 8-20 WS request + 5 Mongo query). Cap
// enforcement KHÔNG phụ thuộc poll (elearning-cap-enforcer middleware
// reject ở mỗi API call ngay lập tức), poll chỉ để hiển thị overlay
// + cập nhật pill "Cập nhật lúc HH:MM" ở trang Result. Pill cũng đã
// hiển thị "Tự cập nhật mỗi 10 phút" để HV biết.
const ELEARNING_POLL_INTERVAL = 10 * 60 * 1000; // 10 phút

export {
    ELEARNING_ROLES,
    QUIZ_ATTEMPT_STATUS,
    COURSE_MODULES,
    QUIZ_GRADE_STATUS,
    ELEARNING_POLL_INTERVAL
}
